import { LitElement, html, css, render } from 'lit';
import { icons } from '../../utilities/icons';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInMultiloader extends LitElement {
    static properties = {
        buttonText: { type: String },
        icon: { type: String },
        show: { type: Number, state: true },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        //this._handleHideReveal();
        this.hasGroups = false;
        this.hasInitialised = false;
    }
    async firstUpdated() {
        if (!this.hasGroups) {
            if (!this.groups) {
                this.groups = this.renderRoot.querySelectorAll('.group');
            }
            if (!this.groups.length) {
                while (!this.groups.length) {
                    await new Promise((resolve) => requestAnimationFrame(resolve));
                    this.groups = this.renderRoot.querySelectorAll('.group');
                }
            }
            if (this.groups.length) {
                this.hasGroups = true;
                this.groups.forEach((group, i) => {
                    if (i == 0) {
                        return;
                    }
                    let button = html `\n                        <button class="button_secondary" @click=${this._removeUploader.bind(this)}><span aria-hidden="true">${icons['closeAlt']}</span>Tynnu</button>\n                    `;
                    let buttonDiv = document.createElement('div');
                    render(button, buttonDiv);
                    group.appendChild(buttonDiv);
                });
                let button = this.renderRoot.querySelector('.add_uploader');
                if (button) {
                    if (button.nextElementSibling && button.nextElementSibling.classList.contains('group')) {
                        let lastGroup = this.groups[this.groups.length - 1];
                        lastGroup.after(button);
                    }
                }
            }
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `\n           <button class="add_uploader button_secondary" @click=${this._addUploader}><span aria-hidden="true">${this._getIcon()}</span>${this.buttonText ?? `Lanlwytho mwy o ddelweddau`}</button>\n        `;
    }
    _handleHideReveal() {
        /* if(!this.groups){
            this.groups = this.renderRoot.querySelectorAll('.group');
        }
        if(!this.groups.length){
            //Sometimes it seems to render the light dom stuff after the updated callback
            setTimeout(()=>{this.groups = this.renderRoot.querySelectorAll('.group');},200);
        } */
        this.count = this.groups.length;
        this.show = 0;
        if (this.count) {
            this.groups.forEach((group) => {
                if (group.classList.contains('show')) {
                    this.show++;
                    group.style.display = 'block';
                }
                else {
                    if (group.querySelector('img')?.dataset?.has_src == 'true') {
                        group.style.display = 'block';
                        group.classList.add('show');
                        this.show++;
                    }
                    else {
                        group.style.display = 'none';
                    }
                }
            });
        }
        let button = this.renderRoot.querySelector('.add_uploader');
        if (this.show == this.count) {
            if (button) {
                button.style.display = 'none';
            }
        }
        else {
            if (button) {
                button.style.display = 'block';
            }
        }
    }
    _addUploader(e) {
        e.preventDefault();
        this._handleHideReveal();
        this.groups[this.show].classList.add('show');
        this._handleHideReveal();
        if (this.show == this.count) {
            this.renderRoot.querySelector('.add_uploader').style.display = 'none';
        }
    }
    _removeUploader(e) {
        e.preventDefault();
        let group = e.target.closest('.group');
        group.classList.remove('show');
        let inputs = group.querySelectorAll('input,select,textarea');
        inputs.forEach((input) => {
            if (input.type == 'checkbox' || input.type == 'radio') {
                input.checked = false;
            }
            else {
                input.value = '';
            }
            const event = new Event('change', { bubbles: true, composed: true });
            input.dispatchEvent(event);
        });
        this._handleHideReveal();
        this.renderRoot.querySelector('.add_uploader').style.display = 'block';
    }
    _getIcon() {
        if (this.icon) {
            return icons[this.icon];
        }
        return icons['addIcon'];
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .group{
                display:none;
            }
            .add_uploader{
                margin-bottom:1rem;
            }
            
        `
    ];
}
